import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { debounce, Skeleton } from "@mui/material";

export type AutocompleteOption = {
  label: string;
  value: any;
};

type Props = {
  value: AutocompleteOption | null;
  onChange: (value: AutocompleteOption | null) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  options: AutocompleteOption[];
  label?: string;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
};

export function SearchAutocomplete({
  value,
  onChange,
  inputValue,
  onInputChange,
  options,
  label,
  placeholder,
  loading,
  disabled,
}: Props) {
  const [firstRender, setFirstRender] = React.useState(true);
  const [inputKeyWord, setInputKeyWord] = React.useState("");

  React.useEffect(() => {
    if (value && firstRender) {
      setInputKeyWord(value.label);
      setFirstRender(false);
    }
  }, [value]);

  return (
    <Autocomplete
      options={options}
      value={value}
      inputValue={undefined}
      onChange={(_, newValue) => {
        onChange(newValue);

        // 🔥 Sync input text with selected label
        if (newValue) {
          onInputChange(newValue.label);
        } else {
          onInputChange("");
        }
      }}
      onInputChange={(_, newInput, reason) => {
        // 🔥 Only update when user types
        if (reason === "input") {
          onInputChange(newInput);
        }

        // 🔥 Clear button
        if (reason === "clear") {
          onInputChange("");
        }
      }}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      loading={loading}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  );
}
